import Main from './Main'
import Lista from './components/CadastroNotificacaoProcessoLista'
import Novo from './components/NovoCadastroNotificacaoProcesso'

export default [
  {
    path: 'cadastro-notificacao-processo',
    name: 'roubo-furto.cadastro-notificacao-processo',
    component: Main,
    redirect: { name: 'roubo-furto.cadastro-notificacao-processo.list' },
    children: [
      {
        path: '/',
        name: 'roubo-furto.cadastro-notificacao-processo.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'roubo-furto.cadastro-notificacao-processo.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'roubo-furto.cadastro-notificacao-processo.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/roubo-furto/cadastro-notificacao-processo/routes.js